import * as Moff from '../constants/MoffAPI';
import { MoffAPI } from '../api/MoffAPI';
import { HomeVisitAPI } from '../api/HomeVisit';
import { SERVICE_ERR_MSG } from '../constants/HomeVisit';
import { InterestCheckAPI } from '../api/InterestCheckAPI';
import * as AppUser from '../constants/AppUser';
import * as MoffAPIConst from '../constants/MoffAPI';
import * as KirokuConst from '../constants/Kiroku';

// getDetailDataの入れ子になっている3番目の関数.
const getMonthlyDataFunc = (moff: MoffAPI, params: any[], resultOfGetTraining: any, resultOfGetUser: any) => {
  return moff.getMonthlyData(
    params[2][0], params[2][1], params[2][2],
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (statusOfGetMonthlyData: any, resultOfGetMonthlyData: any) => {
      switch (statusOfGetMonthlyData) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: resultOfGetTraining,
          };
        case Moff.SUCCESS:
          return {
            type: Moff.SUCCESS,
            result: {
              // a: getTraining();
              // b: getUser(userId);
              // c: getMonthlyData(1, userId, '2017-08');
              training: resultOfGetTraining,
              user: resultOfGetUser,
              monthlyData: resultOfGetMonthlyData,
            },
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

// getTrainingDetailDataの入れ子になっている3番目の関数.
const getFunctionalTrainingHistoryFunc = (moff: MoffAPI, params: any[], resultOfGetTraining: any,
                                          resultOfGetUser: any) => {
  const userId: string = params[2][0];
  const startDate: string = params[2][1];
  const endDate: string = params[2][2];
  return moff.getFunctionalTrainingHistory(
    userId, startDate, endDate,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (statusOfGetFunctionalTrainingHistory: any, resultOfGetFunctionalTrainingHistory: any) => {
      switch (statusOfGetFunctionalTrainingHistory) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: resultOfGetTraining,
          };
        case Moff.SUCCESS:
          return {
            type: Moff.SUCCESS,
            result: {
              // a: getTraining();
              // b: getUser(userId);
              // c: getFunctionalTrainingHistory(userId, '2018-02-01', '2018-02-10');
              training: resultOfGetTraining,
              user: resultOfGetUser,
              filteredTraining: resultOfGetFunctionalTrainingHistory,
            },
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

// getDetailData または getTrainingDetailDataの入れ子になっている2番目の関数.
// isTraining(個別機能訓練に関する記録用)のフラグでどちらか分岐.
const getUserFunc = (moff: MoffAPI, params: any[], resultOfGetTraining: any, isTraining: boolean = false) => {
  return moff.getUser(
    params[1],
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (statusOfGetUser: any, resultOfGetUser: any) => {
      switch (statusOfGetUser) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: resultOfGetUser,
          };
        case Moff.SUCCESS:
          // isTraining(個別機能訓練に関する記録用)のフラグでどちらか分岐.
          if (isTraining) {
            // getTrainingDetailData
            return getFunctionalTrainingHistoryFunc(moff, params, resultOfGetTraining, resultOfGetUser);
          }

          // getDetailData 
          return getMonthlyDataFunc(moff, params, resultOfGetTraining, resultOfGetUser);
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

// 以下を複数同時.
// getTraining();
// getUser(userId);
// getMonthlyData(1, userId, '2017-08');
export const getDetailData = (params: any[]) => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  // 1つ目.
  return moff.getTraining(
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (statusOfGetTraining: any, resultOfGetTraining: any) => {
      switch (statusOfGetTraining) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: resultOfGetTraining,
          };
        case Moff.SUCCESS:
          return getUserFunc(moff, params, resultOfGetTraining);
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

// 12ヶ月行う.
const getMonthlyDataRepeatFunc = (moff: MoffAPI, userId: string, yearMonthArr: string[], resultOfGetUser: any) => {
  // LocomoとADL用にYYYY-MMを交互にAPIのパラメータに渡すため重複させる.
  const duplicatedYearMonthArr: string[] = [];
  for (let i = 0; i < yearMonthArr.length; i++) {
    duplicatedYearMonthArr.push(yearMonthArr[i]);
    duplicatedYearMonthArr.push(yearMonthArr[i]);
  }

  const requestFunc = () => {
    return {
      type: Moff.LOADING,
      result: null,
    };
  };

  // '2017-07'のYYYY-MMがキー, 中身は個数(LocomoとADLで片方さえ入れば良い).
  const resultYearMonthObj: object = {};

  let index: number = 0;

  const currentType = (): number => {
    return (index % 2 === 0) ? MoffAPIConst.LOCOMO_TYPE : MoffAPIConst.ADL_TYPE;
  };

  // ステータス,結果（値 or エラーメッセージ）
  const fetchedFunc = (status: any, result: any) => {
    switch (status) {
      case Moff.LOADING:
        return {
          type: Moff.LOADING,
          result: null,
        };
      case Moff.ERROR:
        return {
          type: Moff.ERROR,
          result: result,
        };
      case Moff.SUCCESS:
        let obj = result;
        let size: number = 0;

        // YYYY-MM-DDのキーがある.
        let key: string = '';
        for (key in obj) {
          if (obj.hasOwnProperty(key)) {
            size++;
          }
        }
 
        // 結果は複数あるので追加する.
        if (size > 0) {
          const objKey: string = duplicatedYearMonthArr[index];
          resultYearMonthObj[objKey] =  size;
        }

        // 最後に到達するまではLoading.
        if (index < duplicatedYearMonthArr.length - 1) {
          // APIを再帰的に.
          index++;

          return moff.getMonthlyData(
            currentType(), userId, duplicatedYearMonthArr[index],
            requestFunc,
            fetchedFunc
          );
        } else {
          // 最終的.
          return {
            type: Moff.SUCCESS,
            result: {
              user: resultOfGetUser,
              dispYearMonth: resultYearMonthObj
            },
          };
        }
      default:
        return {
          type: Moff.ERROR,
          result: '不明なエラーが発生しました.',
        };
    }
  };

  // API.
  return moff.getMonthlyData(
    currentType(), userId, duplicatedYearMonthArr[index],
    requestFunc,
    fetchedFunc
  );
};

// モフトレ通信・月選択.
// 以下を複数同時.
// getUser(userId);
// x12
// getMonthlyData(1, userId, '2017-08'); LocomoとADL.
// getMonthlyData(2, userId, '2017-08');
export const getMoffTrainingData = (userId: string, yearMonthArr: string[]) => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return moff.getUser(
    userId,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (statusOfGetUser: any, resultOfGetUser: any) => {
      switch (statusOfGetUser) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: resultOfGetUser,
          };
        case Moff.SUCCESS:
          return getMonthlyDataRepeatFunc(moff, userId, yearMonthArr, resultOfGetUser);
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

// 以下を複数同時.
// getTraining();
// getUser(userId);
// getFunctionalTrainingHistory(userId, '2018-02-01', '2018-02-10');
export const getTrainingDetailData = (params: any[]) => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  // 1つ目.
  return moff.getTraining(
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (statusOfGetTraining: any, resultOfGetTraining: any) => {
      switch (statusOfGetTraining) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: resultOfGetTraining,
          };
        case Moff.SUCCESS:
          return getUserFunc(moff, params, resultOfGetTraining, true);
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

// Locomo, ADLで行う.
const getMonthlyDetailDataRepeatFunc = (moff: MoffAPI, userId: string, yearMonth: string, resultOfGetUser: any) => {
  const requestFunc = () => {
    return {
      type: Moff.LOADING,
      result: null,
    };
  };

  let index: number = 0;
  let locomoResult: any;

  // ステータス,結果（値 or エラーメッセージ）
  const fetchedFunc = (status: any, adlResult: any) => {
    switch (status) {
      case Moff.LOADING:
        return {
          type: Moff.LOADING,
          result: null,
        };
      case Moff.ERROR:
        return {
          type: Moff.ERROR,
          result: adlResult,
        };
      case Moff.SUCCESS:
        // 最後に到達するまではLoading.
        if (index < 1) {
          locomoResult = adlResult;

          // APIを再帰的に.
          index++;

          return moff.getMonthlyData(
            MoffAPIConst.ADL_TYPE, userId, yearMonth,
            requestFunc,
            fetchedFunc
          );
        } else {
          // 最終的.
          return {
            type: Moff.SUCCESS,
            result: {
              user: resultOfGetUser,
              locomo: locomoResult,
              adl: adlResult,
            },
          };
        }
      default:
        return {
          type: Moff.ERROR,
          result: '不明なエラーが発生しました.',
        };
    }
  };

  // API.
  return moff.getMonthlyData(
    MoffAPIConst.LOCOMO_TYPE, userId, yearMonth,
    requestFunc,
    fetchedFunc
  );
};

// モフトレ通信・詳細.
// 以下を複数同時.
// getUser(userId);
// getMonthlyData(1, userId, '2017-08'); LocomoとADL.
// getMonthlyData(2, userId, '2017-08');
export const getMoffDetailData = (userId: string, yearMonth: string) => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return moff.getUser(
    userId,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (statusOfGetUser: any, resultOfGetUser: any) => {
      switch (statusOfGetUser) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: resultOfGetUser,
          };
        case Moff.SUCCESS:
          // ユーザ情報のみ表示.
          if (yearMonth ===  '') {
            return {
              type: Moff.SUCCESS,
              result: {
                user: resultOfGetUser,
                locomo: null,
                adl: null,
              }
            };
          } else {
            return getMonthlyDetailDataRepeatFunc(moff, userId, yearMonth, resultOfGetUser);
          }
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

// 利用者一覧取得(1人)
export const getUser = (userId: string) => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return moff.getUser(
    userId,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (status: any, result: any) => {
      switch (status) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result,
          };
        case Moff.SUCCESS:
          return {
            type: Moff.SUCCESS,
            result: result,
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

// トレーニング取得
export const getTraining = () => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return moff.getTraining(
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (status: any, result: any) => {
      switch (status) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result,
          };
        case Moff.SUCCESS:
          return {
            type: Moff.SUCCESS,
            result: result,
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

// 利用者一覧取得(複数)
export const getUsers = () => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return moff.getUsers(
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (status: any, result: any) => {
      switch (status) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result,
          };
        case Moff.SUCCESS:
          return {
            type: Moff.SUCCESS,
            result: result,
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

// 以下のAPIを複数同時.
// getMonthlyData(1, userId, '2017-08');
// 最大12回.
export const getLongTermData = (type: number, userId: string, params: any[]) => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  let i: number = 0;

  // result array.
  const arr: any[] = [];

  const requestFunc = () => {
    return {
      type: Moff.LOADING,
      result: null,
    };
  };

  // ステータス,結果（値 or エラーメッセージ）
  const fetchedFunc = (status: any, result: any) => {
    switch (status) {
      case Moff.LOADING:
        return {
          type: Moff.LOADING,
          result: null,
        };
      case Moff.ERROR:
        return {
          type: Moff.ERROR,
          result: result,
        };
      case Moff.SUCCESS:
        // 結果は複数あるので追加する.
        arr.push(result);

        // 最後に到達するまではLoading.
        if (i < params.length - 1) {
          // APIを再帰的に.
          i++;

          return moff.getMonthlyData(
            type, userId, params[i],
            requestFunc,
            fetchedFunc
          );
        } else {
          // 最終的.
          return {
            type: Moff.SUCCESS,
            result: {
              longTermData: arr
            },
          };
        }
      default:
        return {
          type: Moff.ERROR,
          result: '不明なエラーが発生しました.',
        };
    }
  };

  // API.
  return moff.getMonthlyData(
    type, userId, params[i],
    requestFunc,
    fetchedFunc
  );
};

// getCompareData のNew取得用メソッド.
const getEndMonthlyData = (moff: MoffAPI, params: any[], type: number, userId: string,
                           resultOfGetStartMonthlyData: any) => {
  return moff.getMonthlyData(
    type, userId, params[1],
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (statusOfGetEndMonthlyData: any, resultOfGetEndMonthlyData: any) => {
      switch (statusOfGetEndMonthlyData) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: resultOfGetEndMonthlyData,
          };
        case Moff.SUCCESS:
          // 3つ目.
          return {
            type: Moff.SUCCESS,
            result: {
              startData: resultOfGetStartMonthlyData,
              endData: resultOfGetEndMonthlyData,
            },
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

// 比較用データ取得.
// getMonthlyDataをstart, endの2回.
export const getCompareData = (type: number, userId: string, params: any[]) => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  // 1つ目(start).
  return moff.getMonthlyData(
    type, userId, params[0],
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (statusOfGetStartMonthlyData: any, resultOfGetStartMonthlyData: any) => {
      switch (statusOfGetStartMonthlyData) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: resultOfGetStartMonthlyData,
          };
        case Moff.SUCCESS:
          // 2つ目(end).
          return getEndMonthlyData(moff, params, type, userId, resultOfGetStartMonthlyData);
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

// 月間データサイズ取得(typeは1 or 2)
// 1: ロコモ予防トレーニング・詳細用
// 2: 日常生活動作トレーニング・詳細用
export const getMonthlyDataSize = (type: number, userId: string, yearmonth: string): any => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return moff.getMonthlyDataSize(
    type, userId, yearmonth,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (status: any, result: any) => {
      switch (status) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result,
          };
        case Moff.SUCCESS:
          return {
            type: Moff.SUCCESS,
            result: result,
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

// 月間データ取得(typeは1 or 2)
// 1: ロコモ予防トレーニング・詳細用
// 2: 日常生活動作トレーニング・詳細用
export const getMonthlyData = (type: number, userId: string, yearmonth: string): any => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return moff.getMonthlyData(
    type, userId, yearmonth,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (status: any, result: any) => {
      switch (status) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result,
          };
        case Moff.SUCCESS:
          return {
            type: Moff.SUCCESS,
            // result: result,
            // 3つ同時getDetailData()のAPIと合わせるためmonthlyDataをキーにする.
            result: {
              monthlyData: result,
            },
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

// トレーニング履歴・取得
// 注意
// startDate, endDateを'2018-01', '2018-02'の月までの形式ではなく
// startDate, endDateを'2018-01-26', '2018-02-02'のように日も忘れずに指定する事。
export const getFunctionalTrainingHistory = (userId: string, startDate: string, endDate: string): any => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return moff.getFunctionalTrainingHistory(
    userId, startDate, endDate,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (status: any, result: any) => {
      switch (status) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result,
          };
        case Moff.SUCCESS:
          return {
            type: Moff.SUCCESS,
            result: result,
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

// トレーニング履歴・追加
/*
  paramsの例
    const params={
        'datetime': getCurTime(),
        'duration': "00:15:00",
        'subject': "ベンチプレス220Kg",
        'instructor': "坂本慎太郎",
        'remarks': "だいぶ仕上がってきました",
    };
*/
export const postFunctionalTrainingHistory = (userId: string, params: KirokuConst.NewParamFormat): any => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return moff.postFunctionalTrainingHistory(
    userId, params,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (status: any, result: any) => {
      switch (status) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result,
          };
        case Moff.SUCCESS:
          return {
            type: Moff.SUCCESS,
            result: result,
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

// 以下のAPIを複数同時.
// 新規と更新を同時に.
// postFunctionalTrainingHistory と　putFunctionalTrainingHistory
export const postAndPutFunctionalTrainingHistory = (userId: string, timeTexConvertedArr: string[],
                                                    postParams: KirokuConst.NewParamFormat[],
                                                    putParams: KirokuConst.NewParamFormat[]) => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  // result array.
  const arr: any[] = [];

  const requestFunc = () => {
    return {
      type: Moff.LOADING,
      result: null,
    };
  };

  // PUT(更新)用.
  let putIndex: number = 0;

  // ステータス,結果（値 or エラーメッセージ）
  // PUT(更新)用.
  const fetchedFuncForPut = (status: any, result: any) => {
    switch (status) {
      case Moff.LOADING:
        return {
          type: Moff.LOADING,
          result: null,
        };
      case Moff.ERROR:
        return {
          type: Moff.ERROR,
          result: result,
        };
      case Moff.SUCCESS:
        // 結果は複数あるので追加する.
        arr.push(result);

        // 最後に到達するまではLoading.
        if (putIndex < putParams.length - 1) {
          // APIを再帰的に.
          putIndex++;

          // PUT(更新)
          return moff.putFunctionalTrainingHistory(
            userId, putParams[putIndex], timeTexConvertedArr[putIndex], 
            requestFunc,
            fetchedFuncForPut
          );
        } else {
          // 最終的.
          return {
            type: Moff.SUCCESS,
            result: {
              longTermData: arr
            },
          };
        }
      default:
        return {
          type: Moff.ERROR,
          result: '不明なエラーが発生しました.',
        };
    }
  };

  // POST(新規)用.
  let postIndex: number = 0;

  // ステータス,結果（値 or エラーメッセージ）
  // POST(新規)用.
  const fetchedFuncForPost = (status: any, result: any) => {
    switch (status) {
      case Moff.LOADING:
        return {
          type: Moff.LOADING,
          result: null,
        };
      case Moff.ERROR:
        return {
          type: Moff.ERROR,
          result: result,
        };
      case Moff.SUCCESS:
        // 結果は複数あるので追加する.
        arr.push(result);

        // 最後に到達するまではLoading.
        if (postIndex < postParams.length - 1) {
          // APIを再帰的に.
          postIndex++;

          // POST(新規)
          return moff.postFunctionalTrainingHistory(
            userId, postParams[postIndex],
            requestFunc,
            fetchedFuncForPost
          );
        } else {
          if (!putParams || putParams.length === 0) {
            // PUTがないとき最終.
            return {
              type: Moff.SUCCESS,
              result: {
                longTermData: arr
              },
            };
          } else {
            // PUTもあれば更新.
            // PUT(更新)
            return moff.putFunctionalTrainingHistory(
              userId, putParams[putIndex], timeTexConvertedArr[putIndex],
              requestFunc,
              fetchedFuncForPut
            );
          }
        }
      default:
        return {
          type: Moff.ERROR,
          result: '不明なエラーが発生しました.',
        };
    }
  };

  // 両方ない時もありえるのでそのまま終わらせる.
  if (postParams.length === 0 && putParams.length === 0) {
    return {
      type: Moff.SUCCESS,
      result: {
        longTermData: arr
      }
    };
  }

  // Updateしかないときもある.
  if (!postParams || postParams.length === 0) {
    // PUT(更新用)API.
    return moff.putFunctionalTrainingHistory(
      userId, putParams[putIndex], timeTexConvertedArr[putIndex],
      requestFunc,
      fetchedFuncForPut
    );
  } else {
    // POST(新規用)API.
    return moff.postFunctionalTrainingHistory(
      userId, postParams[postIndex],
      requestFunc,
      fetchedFuncForPost
    );
  }
};

// トレーニング履歴・変更
/*
  paramsとtime_texの例
    const params={
        'duration': "02:00:00",
        'subject': "腕立て 3回",
        'instructor': "斉木俊介",
        'remarks': "とてもよくできましたね！",
        'print': 0
    };
    const time_tex="2017-06-08 09:35 a25038e7-0842-46a5-a80e-dfb7bd23bab4";
*/
// timeTexConverted: DB内のdatetimeをconvertTimeで変換しその結果の'ux-qa'の事
export const putFunctionalTrainingHistory = (userId: string, params: KirokuConst.UpdateParamFormat,
                                             timeTexConverted: string): any => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return moff.putFunctionalTrainingHistory(
    userId, params, timeTexConverted,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (status: any, result: any) => {
      switch (status) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result,
          };
        case Moff.SUCCESS:
          return {
            type: Moff.SUCCESS,
            result: result,
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

// トレーニング履歴・削除
// timeTexConverted: DB内のdatetimeをconvertTimeで変換し、その結果の'ux-qa'の事
export const deleteFunctionalTrainingHistory = (userId: string, timeTexConverted: string) => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return moff.deleteFunctionalTrainingHistory(
    userId, timeTexConverted,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (status: any, result: any) => {
      switch (status) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result,
          };
        case Moff.SUCCESS:
          return {
            type: Moff.SUCCESS,
            result: result,
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

// 興味関心チェック.
// 件数取得.
// AppUserのAPIから呼ばれるのでAppUserの定数を使用.
export const getInterestCheckRecordCount = (uniqueId: string) => {
  // API
  const interestCheck = InterestCheckAPI.instance;
  if (interestCheck === null) {
    return {
      type: AppUser.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return interestCheck.getRecordCount(
    uniqueId,
    () => {
      return {
        type: AppUser.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (status: any, result: any) => {
      switch (status) {
        case Moff.LOADING:
          return {
            type: AppUser.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: AppUser.ERROR,
            result: result,
          };
        case Moff.SUCCESS:
          if (result.total === 0) {
            // いないメッセージ.
            alert(SERVICE_ERR_MSG);

            return {
              type: AppUser.ERROR,
              result: null,
            };
          }
          return {
            type: AppUser.SUCCESS,
            result: {
              uniqueId: uniqueId,
              total: result.total,
            }
          };
        default:
          return {
            type: AppUser.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

/**
 * 居宅訪問・興味関心チェック.
 * 指定の1件を取得するときに一緒にユーザ情報も取得.
 *
 * @param {*} result
 * @param {string} userId
 * @returns
 */
const getUserInfo = (result: any, userId: string) => {
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  // ユーザ情報.
  return moff.getUser(
    userId,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (statusOfGetUser: any, resultOfGetUser: any) => {
      switch (statusOfGetUser) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: resultOfGetUser,
          };
        case Moff.SUCCESS:
          return {
            type: Moff.SUCCESS,
            result: {
              // キー.
              homeVisit: result,
              interestCheck: result,
              user: resultOfGetUser
            }
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

/**
 * モフトレチェック・詳細.
 *
 * @param {string} userId
 * @returns
 */
export const getMoffCheckDetailData = (userId: string) => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  // ユーザ情報.
  return moff.getUser(
    userId,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (statusOfGetUser: any, resultOfGetUser: any) => {
      switch (statusOfGetUser) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: resultOfGetUser,
          };
        case Moff.SUCCESS:
          //  自分の施設取得.
          return moff.getInstitutions(
            () => {
              return {
                type: Moff.LOADING,
                result: null,
              };
            },
            // ステータス,結果（値 or エラーメッセージ）
            (status: any, result: any) => {
              switch (status) {
                case Moff.LOADING:
                  return {
                    type: Moff.LOADING,
                    result: null,
                  };
                case Moff.ERROR:
                  return {
                    type: Moff.ERROR,
                    result: result,
                  };
                case Moff.SUCCESS:
                  return {
                    type: Moff.SUCCESS,
                    result: {
                      user: resultOfGetUser,
                      institutions: result,
                    },
                  };
                default:
                  return {
                    type: Moff.ERROR,
                    result: '不明なエラーが発生しました.',
                  };
              }
            }
          );
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

/* 興味関心チェック・指定の1件を取得.
 *
 * @param {string} userId
 * @param {string} uniqueId
 * @param {number} sequence
 * @returns
 */
export const getInterestCheckRecord = (userId: string, uniqueId: string, sequence: number) => {
  // API
  const interestCheck = InterestCheckAPI.instance;
  if (interestCheck === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return interestCheck.getRecord(
    uniqueId, sequence,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (status: any, result: any) => {
      switch (status) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result,
          };
        case Moff.SUCCESS:
          if (userId === '') {
            return {
              type: Moff.SUCCESS,
              result: {
                interestCheck: result
              }
            };
          }

          // 指定の1件を取得するときに一緒にユーザ情報も取得.
          return getUserInfo(result, userId);
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

/**
 * 居宅訪問・指定の1件を取得.
 *
 * @param {string} userId
 * @param {string} uniqueId
 * @param {number} sequence
 * @returns
 */
export const getHomeVisitRecord = (userId: string, uniqueId: string, sequence: number) => {
  // API
  const homeVisit = HomeVisitAPI.instance;
  if (homeVisit === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return homeVisit.getRecord(
    uniqueId, sequence,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (status: any, result: any) => {
      switch (status) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result,
          };
        case Moff.SUCCESS:
          if (userId === '') {
            return {
              type: Moff.SUCCESS,
              result: {
                homeVisit: result
              }
            };
          }

          // 指定の1件を取得するときに一緒にユーザ情報も取得.
          return getUserInfo(result, userId);
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

// 居宅訪問.
// 件数取得.
// AppUserのAPIから呼ばれるのでAppUserの定数を使用.
export const getHomeVisitRecordCount = (uniqueId: string) => {
  // API
  const homeVisit = HomeVisitAPI.instance;
  if (homeVisit === null) {
    return {
      type: AppUser.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return homeVisit.getRecordCount(
    uniqueId,
    () => {
      return {
        type: AppUser.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (status: any, result: any) => {
      switch (status) {
        case Moff.LOADING:
          return {
            type: AppUser.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: AppUser.ERROR,
            result: result,
          };
        case Moff.SUCCESS:
          if (result.total === 0) {
            // いないメッセージ.
            alert(SERVICE_ERR_MSG);
            return {
              type: AppUser.ERROR,
              result: null,
            };
          }

          return {
            type: AppUser.SUCCESS,
            result: {
              uniqueId: uniqueId,
              total: result.total,
            }
          };
        default:
          return {
            type: AppUser.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};



// WEBPACK FOOTER //
// ./src/actions/MoffAPI.tsx